import { ExclamationCircleIcon, XCircleIcon } from '@heroicons/react/24/solid';
import { Tooltip } from '@kira/checkpoint-shared-frontend';
import React from 'react';
import { twMerge } from 'tailwind-merge';

import Spinner from 'assets/Spinner';
import { t } from 'locales/i18n';

interface QuestionCardWithStatusProps {
  isUploading?: boolean;
  uploadedFileText?: string;
  errorMessage?: string;
  index?: number;
  handleDismiss?: (index: number) => void;
}

const QuestionCardWithStatus = ({
  isUploading,
  uploadedFileText,
  errorMessage,
  index,
  handleDismiss,
}: QuestionCardWithStatusProps) => {
  const questionWrapperClassName = twMerge(
    'border',
    'border-kira-slate-200',
    'bg-kira-slate-50',
    'rounded-lg',
    'py-3',
    'px-4',
    'transition'
  );

  return (
    <div className={questionWrapperClassName}>
      <div className="flex items-center justify-between">
        <div className="flex grow cursor-default text-left">
          <div className="flex items-center">
            <div className="relative">
              {isUploading && (
                <Spinner spinnerClassNames="w-6 h-6 text-kira-violet-900 animate-spin" />
              )}

              {!!errorMessage && (
                <ExclamationCircleIcon className="h-6 w-6 text-kira-red-800 transition ease-linear" />
              )}
            </div>
            <div className="ml-2">
              <p className="prose-body-md-med text-kira-slate-900">
                {uploadedFileText}
              </p>
              {isUploading && (
                <div className="prose-body-sm-reg flex items-center pt-1 italic text-kira-slate-700">
                  {t('Uploading...')}
                </div>
              )}
              {!!errorMessage && (
                <div
                  className="prose-body-sm-reg flex items-center pt-1 text-kira-red-800"
                  data-testid="errorMessage"
                >
                  {errorMessage}
                </div>
              )}
            </div>
          </div>
        </div>
        {!!errorMessage && handleDismiss && index !== undefined && (
          <Tooltip
            textContent={t('Dismiss')}
            tooltipClassNames="bottom-10 -left-6 !mt-0"
            tooltipWrapperClassNames="relative"
          >
            <button
              className="pt-2"
              type="button"
              onClick={() => handleDismiss(index)}
            >
              <XCircleIcon className="h-6 w-6 text-kira-slate-700 hover:text-kira-red-800" />
            </button>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default QuestionCardWithStatus;
